import React from 'react';
import FormInputSearch from './FormInputSearchItem';
import RepairSearch from '../../search/RepairSearch';

export default function FormInputRepairSearch(props) {
  return <FormInputSearch {...props} searchComponent={RepairSearch} />;
}
